import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12f664f6&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=12f664f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f664f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f664f6')) {
      api.createRecord('12f664f6', component.options)
    } else {
      api.reload('12f664f6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12f664f6&scoped=true&lang=pug", function () {
      api.rerender('12f664f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultant/material/materialTable/index.vue"
export default component.exports